import { ConversationCloseIconButton } from "@circle-react-shared/AiConversation/header/ConversationCloseIconButton";
import { ConversationHeaderBar } from "@circle-react-shared/AiConversation/header/ConversationHeaderBar";
import { ConversationLoadingSkeleton } from "@circle-react-shared/AiConversation/thread/ConversationLoadingSkeleton";
import { aiAgentQueries } from "@circle-react/lib/queries/aiAgents";
import { Typography } from "@circleco/compass/components/Typography";
import { useQuery } from "react-query";
import { useShallow } from "zustand/react/shallow";

import { t } from "@/i18n-js/instance";

import { useAvatarConversationPanelStore } from "../useAvatarConversationPanelStore";
import { AvatarsList } from "./AvatarsList";
import { ChatsList } from "./ChatsList";

export const AvatarsView = () => {
  const { closePanel, selectAvatar } = useAvatarConversationPanelStore(
    useShallow(s => ({
      closePanel: s.closePanel,
      selectAvatar: s.selectAvatar,
    })),
  );
  const { data: avatars, isPending } = useQuery(aiAgentQueries.memberAvatars());

  return (
    <>
      <div className="shrink-0 border-b border-primary">
        <ConversationHeaderBar>
          <Typography variant="heading-sm" truncate>
            {t("avatars.conversation_panel.chats_title")}
          </Typography>
          <ConversationCloseIconButton
            data-testid="avatar-conversation-panel-close"
            icon="cross"
            label={t("circle_ai_shell.close_panel")}
            onClose={closePanel}
          />
        </ConversationHeaderBar>
      </div>
      <div className="mx-auto flex min-h-0 w-full max-w-2xl flex-1 flex-col gap-10 overflow-y-auto p-6">
        {isPending && <ConversationLoadingSkeleton />}
        {avatars && (
          <AvatarsList
            avatars={avatars}
            onSelect={avatar =>
              selectAvatar({ avatarId: avatar.id, chatId: null })
            }
          />
        )}
        <ChatsList />
      </div>
    </>
  );
};
